export default "__VITE_ASSET__6lqaqyka__"